export enum PlanningActionTypes {
  GET_PLANNINGS_PENDING = '@@planning/GET_PLANNINGS_PENDING',
  GET_PLANNINGS_SUCCESS = '@@planning/GET_PLANNINGS_SUCCESS',
  GET_PLANNINGS_ERROR = '@@planning/GET_PLANNINGS_ERROR',
  SET_CURRENT_DATE = '@@planning/SET_CURRENT_DATE',
  SET_PBX_STATUS = '@@planning/SET_PBX_STATUS'
}
